import store from '@/config/vuex'

export function registerStores(stores) {
  for (const storeName in stores) {
    if (!store.state[storeName]) store.registerModule(storeName, stores[storeName])
  }
}
